<template>
<section class="concept-section _edit-section">

    <div class="concept-item">
        <h2 class="heading-section">その他の取扱いブランド</h2>
        <textarea maxlength="250" name="edit-concept" id="edit-concept1" class="edit-pen" placeholder="その他の取扱いブランドを250文字以内で入力してください" v-model="other_brand" v-bind:class="{ '_error': this.$store.state.register.errors.other_brand }"></textarea>
        <span style="color: red" v-if="$store.state.register.errors.other_brand && other_brand.length<=250">必須項目を入力してください</span>
        <span style="color: red" v-if="$store.state.register.errors.other_brand && other_brand.length>250">コンセプトを250文字以内で入力してください</span>
    </div>

</section><!--/.page-name-row-->
</template>

<script>

export default {
    data() {
        return {
            other_brand: '',
        };
    },
    created() {
        // 編集の場合
        if (this.$store.state.detail.set.brand.other_brand) {
            this.other_brand = this.$store.state.detail.set.brand.other_brand;
            this.$store.state.register.form.other_brand = this.$store.state.detail.set.brand.other_brand;
        }
    },
    watch: {
        other_brand: function (value) {
            this.$store.state.register.form.other_brand = value;
        }
    },
};
</script>